import { CurrencyCode } from "@ternary/api-lib/constants/enums";

export const queryKeys = {
  analyticsExchangeRates: (
    tenantID: string,
    baseCurrencyCode: CurrencyCode,
    quoteCurrencyCode?: CurrencyCode
  ) =>
    [
      "analyticsExchangeRates",
      tenantID,
      baseCurrencyCode,
      quoteCurrencyCode,
    ] as const,
};
